export enum rdeStatusEnum {
    Enable = 1,
    Disable = 2,
    InActive = 3
}

export namespace rdeStatusEnum {
    export function values() {
        return Object.keys(rdeStatusEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
